module.exports = __webpack_public_path__ + "media/application/images/svgs/filter-4b8d722ea45373b0bfb328429f3f80a2.svg";